import React, { useEffect, Fragment } from "react";
import { Link } from 'react-router-dom';
import {ArrowUpRight, ChevronLeft, ChevronRight, Grid} from 'react-feather';

const Upes = (props) => {

    // Adding custom class to body 
    useEffect(() => {
        props.location.pathname === '/' ? document.body.classList.add("home-class") : document.body.classList.add("custom-class");
    })

    return (
        <Fragment>
            <section id="single-project-wrapper">
                <div className="single-project">
                    <div className="container-fluid">
                        <div className="w-full">
                            <div>
                                <div className="h-[100px]"></div>
                                <iframe width="100%" height="650" src="https://www.youtube-nocookie.com/embed/bNuPvjqHsaw?autoplay=1&mute=1&loop=1&playlist=bNuPvjqHsaw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="max-w-default w-default px-12 py-28 lg:py-24 md:py-16 sm:py-4 container-wrapper">
                            <div className="single-project-details">
                                <div className='breadcrumbs pb-4'>
                                    <li><Link to='/'>Home</Link> <span>{'>'}</span> <Link to='/our-work'>Our Work</Link><span>{'>'}</span><Link to='/upes-shakti' className='current'>UPES Shakti</Link></li>
                                </div>
                                <div className="flex lg:flex-row md:flex md:flex-col sm:flex-col single-project-details-wrapper">
                                    <div className="single-project-details-left grid grid-rows-1 grid-cols-2 gap-20">
                                        <div className="details-project-name">
                                            <h3 className="heading5 pb-8">Project Name</h3>
                                            <h1>UPES: Shakti</h1>
                                        </div>
                                        <div>
                                            <h3 className="heading5 pb-8">Type</h3>
                                            <p>Social Media</p>
                                        </div>

                                    </div>
                                    <div className="single-project-details-right lg:pt-0 lg:py-16 md:pt-12">
                                        <div>
                                            <h2 className="heading5 pb-8">The Ask</h2>
                                            <p>
                                            Promote and amplify their new offering - a 25% scholarship to all girl students tagging with their umbrella women empowerment program - <strong>#UPESForShakti</strong>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="single-project-body">
                                    <h2 className="heading4 pb-8">What we did</h2>
                                    <p>An interactive microsite quiz that allows users to glimpse into a world without women. Revolving around everything they'd miss in a world where all the things invented by women didn't exist and highlighted the contribution by women that has become part of our daily lives. The microsite was a vehicle to showcase to all the importance of encouraging women to continue their educational pursuits and drive more interest in the unique scholarship. </p>
                                    <p className="pt-6">The interactive quick was amplified with paid media and Twitter influencers and the key-phrase World Without Women trended nationally for 3 hours a day before Women's Day.</p>
                                    <p className="pt-6"><strong>Website Link: </strong><a href="https://staging1.mslgroup.tech/upes/shakti/" target={"_blank"} rel="noopener noreferrer">https://staging1.mslgroup.tech/upes/shakti/</a></p>
                                  
                                    <h2 className="heading4 pt-16 pb-8 what-campaign-achived">
                                        What the campaign achieved
                                    </h2>
                                    <div className="results">
                                        <div>
                                            <h1>6.33M+</h1>
                                            <h2>Reach</h2>
                                        </div>
                                        <div>
                                            <h1>55K+</h1>
                                            <h2>Unique User Visits</h2>
                                        </div>
                                    </div>

                                    <div className="pagination">
                                        <div><Link to='/godaddy-india'><ChevronLeft/><span>Previous</span></Link></div>
                                        <div><Link to='/our-work'><Grid/><span>All Projects</span></Link></div>
                                        <div><Link to='/pfizer-keep-it-real'><ChevronRight/><span>Next</span></Link></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Footer CTA Ribbon */}
            <section id='take-next-leap' key='single-project'>
                <div className='take-next-leap'>
                    <div className='take-next-leap__left'>
                        <h1 className="heading4 black">Let's create <span>impact together.</span></h1>
                    </div>
                    <div className='take-next-leap__right'>
                        <p><Link to='/contact-us'>Contact us today<ArrowUpRight /></Link></p>
                    </div>
                </div>
            </section>
            {/* Footer CTA Ribbon */}
        </Fragment>
    );
};

export default Upes;